import {getStoredChannel} from "./utils";

export default host => backUrl =>  `${host}/login/provider/miba/profile${backUrl ? `?back_url=${backUrl}` : ''}`